import { InjectionToken, Provider } from "@angular/core";

export const WINDOW = new InjectionToken<Window>('window');

export const WindowProvider: Provider = {
  provide: WINDOW,
  useValue: window
};